import EditPositionReducer from "../FLASH-Hire/components/CreateEditPositionList/reducer";

const rootReducer = {
  EditPositionReducer,
};

export default rootReducer;
